import Validation from "@irati/utils/validation/index"

export const UI = "UI"

export const marketingSchema = Validation.string("account.contact.fields.contact.error")

export const MARKETING_EMAIL_ENABLED = true
export const MARKETING_EMAIL_DISABLED = false

export const options = (formatMessage) => [
  {label: formatMessage({id: "account.contact.fields.contact.option.yes"}), value: MARKETING_EMAIL_ENABLED},
  {label: formatMessage({id: "account.contact.fields.contact.option.no"}), value: MARKETING_EMAIL_DISABLED}
]
